export default __webpack_public_path__ + "static/media/abstracto21152.1d0a3f8c.jpg";